import { useEffect, useRef, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { scrollToElement } from '../../lib/userFunctions';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiStorePhoto } from 'app/readingPicture/apiPicture';
import { toast } from "react-toastify";
import { createFetchErrorMessage } from 'utils/api/Api';

export const ReadingPhotoForm = () => {
    const navigate = useNavigate();
    const { school, isbn } = useParams();
    const [uploadPercent, setUploadPercent] = useState(0);
    const [imagePreview, setImagePreview] = useState(null);
    const [imageFileName, setImageFileName] = useState('');
    const imageFileRef = useRef();

    const queryClient = useQueryClient();

    useEffect(() => scrollToElement('lnb'), []);

    const onUploadProgress = (progressEvent) => {
        setUploadPercent(Math.floor(progressEvent.loaded / progressEvent.total * 100));
    }

    const onChangeFile = (event) => {
        if (imageFileRef.current.files.length === 0) {
            setImagePreview(null);
            setImageFileName('');
            return;
        }

        const file = imageFileRef.current.files[0];
        if (file === null || (file.type !== 'image/jpeg' && file.type !== 'image/png')) {
            setImagePreview(null);
            setImageFileName('');
            return;
        }

        setImagePreview(null);
        setImageFileName(file.name);

        let reader = new FileReader();
        reader.onload = function () {
            setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
    }


    //저장관 관련된
    const storePhotoMutate = useMutation({
        mutationFn: apiStorePhoto,
        onSuccess: (res) => {
            queryClient.invalidateQueries({
                queryKey: ['picture/list', { id: null, isbn: null, best: "N", keyword: "", school: "", type: "photo", page: 0, user: null }]
            });
            navigate(`/${school}/photo`);
        },
        onError: (err) => {
            console.log(err);
            toast.error(createFetchErrorMessage(err).message);
        }
    });

    const onStore = (event) => {
        let formData = new FormData();
        formData.append('isbn', isbn);
        if (imageFileRef.current.value) {
            formData.append('imageFile', imageFileRef.current.files[0]);
        } else {
            alert('파일이 선택되지 않았습니다.');
            return;
        }
        setUploadPercent(0);
        storePhotoMutate.mutate({ data: formData, onUploadProgress });
    }



    return (
        <div className="section create photo_form_container">
            <div className="guide_box">
                <div className="inner">
                    <div>
                        <ul className="bullet_list">
                            <li>손으로 그린 그림, 만들기, 요리, 독서활동지, 체험활동사진 에 이름을 적어, 올려주세요.</li>
                            <li className="warning"><i className="icon fas fa-exclamation-circle"></i>작품에 이름을 적을 수 없는 경우, 종이에 이름을 적어 함께 사진 찍어주세요.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="inner">
            </div>

            <div className="text-center inner">
                <div className="row">
                    <div className="col6 col-md-12 photo_example">
                        <img src={`${process.env.PUBLIC_URL}/static/images/photo/photo_example.jpg`} alt="예시사진" />
                    </div>
                    <div className="col6 col-md-12">
                        <div className="upload_box">
                            <div className={`upload_image ${imagePreview !== null ? 'preview' : ''}`}>
                                {imagePreview !== null && <img src={imagePreview} alt="첨부파일 이미지 미리보기" />}
                            </div>
                            <div className="upload_control">
                                <div className="attach_file">
                                    <input type="text" className="file_name" readOnly="readonly" value={imageFileName} placeholder="선택된 파일 없음" />
                                    <div className="btn_wrap">
                                        <input type="file" ref={imageFileRef} name="image_file" className="input_file" onChange={onChangeFile} />
                                        <label className="btn _sm">파일 선택</label>
                                    </div>
                                    <small><br />반드시 작품에 '내 이름'을 적어 <br />내 작품 인증을 해주세요.</small>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="cont_row">
                <div className="create_btn">
                    <div className="bbs_btn alignC">
                        {!storePhotoMutate.isPending && <button type="button" className="btn _turq" onClick={onStore}>저장</button>}
                        {storePhotoMutate.isPending && uploadPercent + ' %'}
                        <Link className="btn _red" to={`/${school}/book/${isbn}`}>
                            닫기
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}